<script>
export default {
  data() {
    return {
      visible: false,
      config: {
        title: null,
        textSubmitButton: null,
        urlImg: null,
        labelImg: null,
        isCirle: false,
      },
    }
  },

  methods: {
    show(config = {}) {
      this.visible = true
      this.config = { ...this.config, ...config }
    },

    hide() {
      this.visible = false
      this.$emit('hide')
    },

    onSaveAvatar() {
      this.visible = false
    },
  },
}
</script>

<template>
  <s-modal :show="visible">
    <div class="print-image-madal" v-if="visible">
      <p class="btn-close-popup" @click="hide()">
        <x-icon-close />
      </p>
      <div class="print-image-madal_content">
        <div class="image-avatar" :class="config.isCirle ? 'cirle-border' : ''">
          <img :src="config.urlImg" alt="Image.jpeg" />
        </div>
        <p class="print-image-madal_title" v-html="config.title"></p>

        <div class="print-image-madal_button-group">
          <button
            class="s-button blue-btn"
            @click.prevent="onSaveAvatar()"
          >
            {{ config.textSubmitButton }}
          </button>
        </div>
      </div>
    </div>
  </s-modal>
</template>
<style lang="scss" scoped>
@import './modal-print-image.scss';
</style>
